import React from 'react';
import { Datapoint } from '../../dashboard/team-results-store';

interface Props {
    data?: Datapoint;
    hidden?: boolean;
    show?: boolean;
}

export const DistributionBars = ({ data, hidden = false, show = true }: Props): JSX.Element | null => {
    if (!data || hidden || !show) {
        return null;
    }

    const values = [
        { rating: 0, count: data.distributionCounts?.count0 ?? 0 },
        { rating: 25, count: data.distributionCounts?.count25 ?? 0 },
        { rating: 50, count: data.distributionCounts?.count50 ?? 0 },
        { rating: 75, count: data.distributionCounts?.count75 ?? 0 },
        { rating: 100, count: data.distributionCounts?.count100 ?? 0 },
    ];

    const total = values.reduce((sum, v) => sum + v.count, 0);

    return (
        <div className="score-tooltip__vertical-bars">
            {values.map(({ rating, count }) => {
                const height = total > 0 ? (count / total) * 100 : 0;

                return (
                    <div key={rating} className="score-tooltip__vertical-bar-group">
                        <div className="score-tooltip__vertical-bar">
                            <div className="score-tooltip__vertical-bar-container">
                                <div
                                    className={`score-tooltip__vertical-bar-fill rating-${rating}`}
                                    style={{ height: `${height}%` }}
                                >
                                    <span className="score-tooltip__vertical-bar-count">{count}</span>
                                </div>
                            </div>
                            <span className="score-tooltip__vertical-bar-label">{rating}%</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
